import type {FC} from 'react';
import type {SponsoredOption} from '.';
import {useHandleColumnClip} from '../../../usecases/useColumnClip';
import {CardPresentation} from './presentation';

type CardProps = {
  id: string;
  title: string;
  clipCount: number;
  isClipped: boolean;
  componentId?: string;
  tagNames?: string[];
  thumbnail?: string;
  className?: string;
  imageClassName?: string;
  imageSize?: {width: number; height: number};
  sponsoredOption: SponsoredOption;
  updatedAt?: string;
};
export const CardContainer: FC<CardProps> = ({
  id,
  title,
  clipCount,
  isClipped,
  componentId,
  tagNames,
  thumbnail,
  className,
  imageClassName,
  imageSize,
  sponsoredOption,
  updatedAt,
}) => {
  const columnClip = useHandleColumnClip({
    columnId: id,
    clipCount,
    isClipped,
  });

  return (
    <CardPresentation
      id={id}
      title={title}
      thumbnail={thumbnail}
      clip={{
        handler: columnClip.handleClip,
        isClipped: columnClip.isClipped,
        count: columnClip.clipCount,
      }}
      componentId={componentId}
      tagNames={tagNames}
      className={className}
      imageClassName={imageClassName}
      imageSize={imageSize}
      sponsoredOption={sponsoredOption}
      updatedAt={updatedAt}
    />
  );
};
